/**
 * CRM Configuration
 * Manages environment-specific CRM API URLs and feature flags
 */

console.log("[CONFIG DEBUG] Raw NEXT_PUBLIC_CRM_API_BASE:", process.env.NEXT_PUBLIC_CRM_API_BASE)
console.log(
  "[CONFIG DEBUG] All environment variables starting with NEXT_PUBLIC:",
  Object.keys(process.env).filter((key) => key.startsWith("NEXT_PUBLIC_")),
)

export const CRM_API_BASE = process.env.NEXT_PUBLIC_CRM_API_BASE?.replace(/\/+$/, "") ?? "https://crm.zipsprout.com/api"

console.log("[CONFIG DEBUG] Final CRM_API_BASE:", CRM_API_BASE)

// Feature flags for features that should be disabled in production
const IS_BETA = process.env.NEXT_PUBLIC_CRM_API_BASE?.includes("betacrm") ?? false

// Debug logs
console.log("[FEATURE FLAGS DEBUG] NEXT_PUBLIC_CRM_API_BASE:", process.env.NEXT_PUBLIC_CRM_API_BASE)
console.log("[FEATURE FLAGS DEBUG] IS_BETA:", IS_BETA)

export const FEATURE_FLAGS = {
  USER_OPTIONS: IS_BETA, // Only enabled in beta
  TEAM_OPTIONS: IS_BETA, // Only enabled in beta
  // Features not listed here are always enabled
}

console.log("[FEATURE FLAGS DEBUG] FEATURE_FLAGS:", FEATURE_FLAGS)
